"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _history = require("history");

var _reactRouter = require("react-router");

var _default = function _default(rootUrl) {
  return (0, _reactRouter.useRouterHistory)(_history.createHistory)({
    basename: rootUrl
  });
};

exports.default = _default;
module.exports = exports.default;